import { createContext } from 'react';
import type { AuthenticatedIdentity } from '../lib/auth/authService';
import type { SandboxSession } from '../lib/sandbox/session';

export type AuthState =
  | { kind: 'bootstrapping' }
  | { kind: 'unauthenticated'; vaultExists: boolean; lastError?: string }
  | { kind: 'authenticating' }
  | { kind: 'authenticated'; identity: AuthenticatedIdentity };

export interface AuthContextValue {
  state: AuthState;
  session: SandboxSession;
  signUp: (email: string, password: string) => Promise<void>;
  signIn: (password: string) => Promise<void>;
  signOut: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
